// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AuthenticationController = function ($scope, $routeParams, $rootScope, $location, $http) {
    $scope.username = "";
    $scope.password = "";
    $scope.accessToken = "";
    $scope.refreshToken = "";

    var escape = encodeURIComponent;

    function param(obj, traditional) {
        var params = [];
        params.add = function(k, v) { this.push(escape(k) + '=' + escape(v)); };

        for (var key in obj)
            params.add(key, obj[key]);
        return params.join('&').replace(/%20/g, '+');
    };

    function transform(tdata) {
        var tmp = param(tdata);
        return tmp;
    };

    $scope.login = function () {
        if ($scope.accessToken != "") {
            $http({
                method: "POST",
                url: baseUrl + "oauth/token",
                params: null,
                data: { "grant_type": "refresh_token", "refresh_token": $scope.refreshToken, "client_id": "51de9d73eb596aefa053093a" },
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                transformRequest: transform,
                cache: false
            }).success(function (data) {
                $scope.password = ""; 
                $scope.accessToken = data["access_token"];
                $scope.refreshToken = data["refresh_token"];
                $rootScope.role = data["role"];
                $http.defaults.headers.common["Authorization"] = "Bearer " + data["access_token"];
                localStorage.setItem('username', $scope.username);
                localStorage.setItem('access_token', $scope.accessToken);
                localStorage.setItem('refresh_token', $scope.refreshToken);
                localStorage.setItem('role', $rootScope.role );

                $location.path("/dashboard");
            });
        } else {
                $http({
                    method: "POST",
                    url: baseUrl + "oauth/token",
                    params: null,
                    data: { "username": $scope.username, "password": $scope.password, "client_id": "51de9d73eb596aefa053093a", "grant_type": "password" },
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    transformRequest: transform,
                    cache: false
                }).success(function (data) {
                    if (data["redirect"]) {
                        $location.path(data["redirect"].replace("#", ""));
                    } else {
                        $scope.password = "";
                        $rootScope.accessToken = data["access_token"];
                        $rootScope.refreshToken = data["refresh_token"];
                        $rootScope.username = $scope.username;
                        $rootScope.role = data["role"];
                        $http.defaults.headers.common["Authorization"] = "Bearer " + data["access_token"];
                        localStorage.setItem('username', $rootScope.username);
                        localStorage.setItem('access_token', $rootScope.accessToken);
                        localStorage.setItem('refresh_token', $rootScope.refreshToken);
                        localStorage.setItem('role', $rootScope.role);
                        $location.path("/tariffs");
                    }
                   
                });
        }
    };
};
AuthenticationController.$inject = ['$scope', '$routeParams', '$rootScope', '$location', '$http'];
